import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: ({ widthDate }) => ({
    width: widthDate,
    height: "40px",
    maxHeight: "40px",
    minHeight: "40px",
    backgroundColor: "#FFF",
    fontSize: 14,
  }),
  title: {
    color: "#BDBDBD",
    fontSize: 14,
    textAlign: "left",
    marginBottom: "2px",
    marginLeft: "35px",
  },
  icon: { fill: "#EA5B13" },
}));

const dateTheme = createTheme({
  palette: {
    secondary: {
      main: "#EA5B13",
      dark: "#EA5B13",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: "Montserrat",
    fontWeightRegular: 500,
    fontSize: 14,
    color: "#4F4F4F",
  },
});

export default function DatePicker({ title, widthDate, handleDate }) {
  const classes = useStyles({ widthDate });
  const [day, setDay] = useState(new Date());
  const [value, setValue] = useState(day);

  const handleChange = (newValue) => {
    setValue(newValue);
   /*  handleDate(new Date(newValue).toISOString()); */
  };

  const handleDayPlus = () => {
    setValue(day.setDate(day.getDate() + 1));
    //handleDate(day.toISOString());
  };

  const handleDayLess = () => {
    setValue(day.setDate(day.getDate() - 1));
    //handleDate(day.toISOString());
  };

  return (
    <Box fullWidth sx={{ marginRight: "30px" }}>
      <p className={classes.title}>{title}</p>
      <IconButton onClick={handleDayLess}>
        <ArrowBackIosIcon color="secondary" fontSize="small" />
      </IconButton>

      <ThemeProvider theme={dateTheme}>
        <LocalizationProvider dateAdapter={DateAdapter}>
          <MobileDatePicker
            value={value}
            inputFormat="DD MMMM YYYY"
            onChange={handleChange}
            renderInput={(params) => (
              <TextField
                className={classes.root}
                size="small"
                color="secondary"
                {...params}
              />
            )}
          />
        </LocalizationProvider>
      </ThemeProvider>

      <IconButton onClick={handleDayPlus}>
        <ArrowForwardIosIcon color="secondary" fontSize="small" />
      </IconButton>
    </Box>
  );
}

DatePicker.defaultProps = {
  widthDate: "200px",
};

DatePicker.propTypes = {
  widthDate: PropTypes.string,
};
